// extracted by mini-css-extract-plugin
module.exports = {"small":"Icon_small__2p9dC","medium":"Icon_medium__BKqq4","big":"Icon_big__xXnxB","huge":"Icon_huge__1CtE2","loader":"Icon_loader__6eJ1k"};